import { render } from "./ConsolidatedList.vue?vue&type=template&id=160bec32"
import script from "@/assets/boq/ConsolidatedList.js?vue&type=script&lang=js"
export * from "@/assets/boq/ConsolidatedList.js?vue&type=script&lang=js"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__